// Copyright 2024 Sadiant Inc. All Rights Reserved. This software is subject to a license agreement. Unauthorized or unlicensed use is prohibited.

// Why this exists:
// Azure Storage Static Website maps /about-us/ → about-us/index.html (with trailing slash),
// but NOT /about-us → about-us/index.html (without trailing slash — returns 404 → root index.html).
// Angular's default UrlSerializer generates href="/about-us" (no slash), so without JS the browser
// fetches the wrong document and always shows the home page.
// This serializer appends a trailing slash so SSG-rendered <a href> values match Azure's expectation.
import { DefaultUrlSerializer, UrlTree } from '@angular/router';

export class TrailingSlashUrlSerializer extends DefaultUrlSerializer {
  override serialize(tree: UrlTree): string {
    const url = super.serialize(tree);
    // Insert trailing slash before any query string or fragment, but never double-slash the root.
    return url.replace(/^(\/[^?#]*[^/?#])(\?|#|$)/, '$1/$2');
  }
}
